require("aframe");
require("aframe-event-set-component");
require("./components/zoom-control");
require("./components/radar");
require("./video");

